export const API_URL = 'https://photo-gal-app.herokuapp.com'

export const PHOTO_API_URL = 'https://photo-gal-app.herokuapp.com/api/photos';
